import { FC } from "react";
import { useAutoTranslation } from "@/entities";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Note, notesControllerRestoreDeleted } from "@/shared/api/generated.ts";
import { UiNoteActionWrapper } from "@/shared/ui";
import { LANG_KEYS, QUERY_KEYS } from "@/shared/constants";
import { FaTrashRestoreAlt } from "react-icons/fa";
import { sortNewest } from "@/shared/utils";
import styled from "styled-components";

interface Props {
  id: string;
}

export const NoteRestore: FC<Props> = ({ id }) => {
  const { t } = useAutoTranslation();
  const queryClient = useQueryClient();

  const restoreMutation = useMutation({
    mutationFn: notesControllerRestoreDeleted,
  });

  const handleSubmit = () => {
    restoreMutation.mutate(id);
    changeInCache();
  };

  const changeInCache = () => {
    const trashData = queryClient.getQueryData(QUERY_KEYS.DELETED) as Note[];
    const updatedTrash = JSON.parse(JSON.stringify(trashData)) as Note[];
    const idx = updatedTrash.findIndex((item) => item.id == id);
    queryClient.setQueryData(QUERY_KEYS.DELETED, () => {
      return updatedTrash.filter((item) => item.id != id).sort(sortNewest);
    });

    const notesData = queryClient.getQueryData(QUERY_KEYS.NOTES) as Note[];
    if (!notesData) return;
    const updateNotes = JSON.parse(JSON.stringify(notesData)) as Note[];
    if (idx != -1) {
      queryClient.setQueryData(QUERY_KEYS.NOTES, () => {
        return [...updateNotes, updatedTrash[idx]].sort(sortNewest);
      });
    }
  };

  return (
    <UiNoteActionWrapper
      onClick={handleSubmit}
      label={t(LANG_KEYS.RETURN.key, LANG_KEYS.RETURN.value)}
      btnClassname="!w-full"
    >
      <Wrapper>
        <FaTrashRestoreAlt size={18} />
        <Text>{t(LANG_KEYS.RETURN.key, LANG_KEYS.RETURN.value)}</Text>
      </Wrapper>
    </UiNoteActionWrapper>
  );
};

const Text = styled.div`
  font-size: 12px;
`;
const Wrapper = styled.div`
  display: flex;
  gap: 15px;
  align-items: center;
  padding: 15px 10px;
`;
